export const FILTER_TABS_NAME = {
  transaction: {value:"Transaction" , name: "Transaction History"},
  referral: {value: "Referral", name: "Referral History",},
  claim: {value: "ClaimXBR", name: "XBR Claims History"},
}


export const MIN_CLAIM_NODE_AMOUNT = 0.001;